import LoginForm from '../components/forms/LoginForm';


export default function LoginView(): JSX.Element {
  return (
    <div className='flex-1 flex justify-center items-center sm:pb-20 border-t-[1px] border-gray-200'>
      <LoginForm />
    </div>
  );
}